import { cn } from 'lib/helpers/utility';

import { MemoComponent } from 'components/practice/BeyondBilling/ElectronicInvoicing/lib/external/configs';
import Typography from 'components/shared/Typography/Typography';

import { GOOD_FAITH_ESTIMATE_TEXT } from '../lib/constants';

const MemoAndInfo = ({ memo }) => {
  return (
    <div className="flex flex-col gap-2 rounded-none bg-neutral-50 px-6 py-3">
      <div className={cn('flex flex-col gap-1', !memo && 'hidden')}>
        <Typography variant="p" size="small" weight="medium" color="neutral-500">
          MEMO
        </Typography>
        <MemoComponent value={memo} />
      </div>
      <div className="flex flex-col">
        <Typography variant="p" size="small" color="neutral-600" className="italic">
          {GOOD_FAITH_ESTIMATE_TEXT}
        </Typography>
      </div>
    </div>
  );
};

export default MemoAndInfo;
